// extracted by mini-css-extract-plugin
export default {"IconButton":"IconButton_IconButton__ZtN2u","Tooltip":"IconButton_Tooltip__uZ22W"};